export const EXTERNAL_LINK_URL = {
  terms: 'https://icone.site/menu/category/terms-of-service/',
  privacyPolicy: 'https://icone.site/menu/category/privacy-policy/',
};
